import React from 'react';
import {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import HomeIcon from '@material-ui/icons/Home';
import RoomIcon from '@material-ui/icons/Room';
import SettingsIcon from '@material-ui/icons/Settings';
import GroupIcon from '@material-ui/icons/Group';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { Link, useHistory  } from 'react-router-dom';

const useStyles = makeStyles({
  root: {
    width: '100%',
    position: 'fixed',
    bottom: 0,
    zIndex:99
  },
});

export default function BottomNav() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [menu, setMenu] = useState(["Position","My Group"])

  return (
    <div>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            {menu[value]}
          </Typography>
        </Toolbar>
      </AppBar>
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        showLabels
        className={classes.root}
        >
        {/* <BottomNavigationAction component={Link} to="/home" label="Home" icon={<HomeIcon />} /> */}
        <BottomNavigationAction component={Link} to="/map" label="Position" icon={<RoomIcon />} />
        <BottomNavigationAction component={Link} to="/mygroup" label="My Group" icon={<GroupIcon />} />
        {/* <BottomNavigationAction component={Link} to="/settings" label="Option" icon={<SettingsIcon />} /> */}
      </BottomNavigation>
    </div>
    
  );
}